import React, { Component } from 'react';

export default class extends Component {
    render() {
        return (
            <div className="ModalFooter">
                {this.props.text}
            </div>
        );
    }
}
